(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/dialogs/payment-confirm.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/dialogs/payment-confirm.js');
'use strict';

class PaymentConfirm extends svs.tur.payment.dialogs.DialogBase {
  constructor(_ref) {
    let {
      products,
      price,
      onConfirm,
      onCancel
    } = _ref;
    super({
      onConfirm,
      onCancel
    });
    this.products = products;
    this.price = price;
    svs.components.account_balance.get(balance => {
      this.accountBalance = balance;
      this.show();
    });
  }
  getTitle() {
    const numberOfTickets = this.products.reduce((a, v) => a + v.count, 0);
    const product = this.products.length > 1 || this.products[0].count > 1 ? "".concat(numberOfTickets, " lotter") : "en ".concat(this.products[0].name);
    return "Vill du betala och ge bort ".concat(product, " f\xF6r ").concat(this.price, " kr?");
  }
  getMessage() {
    return [{
      type: svs.components.dialog.message.TEXT,
      text: this.getCancelableInfo(),
      align: svs.components.dialog.message.align.CENTER
    }, {
      type: svs.components.dialog.message.TEXT,
      text: "Ditt saldo: ".concat(svs.utils.format.Currency(this.accountBalance), " kr"),
      align: svs.components.dialog.message.align.CENTER
    }];
  }
  getActions() {
    return [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        if (this.onCancel) {
          this.onCancel();
        }
      }
    }, {
      title: "Betala ".concat(this.price, " kr"),
      callback: (e, forms, dialog) => {
        dialog.close();
        if (this.onConfirm) {
          this.onConfirm();
        }
      }
    }];
  }
  getCancelableInfo() {
    return "K\xF6pet g\xE5r inte att annullera";
  }
}
svs.tur.payment.api.jupiter.vouchers.dialogs.PaymentConfirm = PaymentConfirm;

 })(window);